<template>
  <el-table :data="tableData" @selection-change="handleSelectionChange">

    <el-table-column type="selection" width="50"></el-table-column>

    <el-table-column type="index" width="50"></el-table-column>
    <el-table-column :label="$t('lang.图片')">
      <template v-slot="scope">
        <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.photo | filterImg"/>

      </template>
    </el-table-column>
    <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
    <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
    <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
    <el-table-column prop="modifyEdition" :label="$t('lang.食谱版本号')"></el-table-column>
    <el-table-column prop="lang" :label="$t('lang.食谱语言')"></el-table-column>
    <el-table-column prop="type" :label="$t('lang.食谱类型')">
      <template v-slot="{row}">
        {{ row.type | recipeType(that) }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('lang.支持型号')">
      <template v-slot="scope">
        <span>{{ scope.row.productModels | filterProduct }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="tags" :label="$t('lang.标签')"></el-table-column>
    <el-table-column prop="lastUpdateTimeStr" :label="$t('lang.更新时间')"></el-table-column>
    <el-table-column label="">
      <template v-slot="{row}">
        <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled/>
      </template>
    </el-table-column>
    <el-table-column fixed="right" :label="$t('lang.操作')" width="380">
      <template v-slot="scope">
        <el-button size="mini" plain type="primary"
                   @click="$router.push({path: '/recipe-detail',  query: { recipeEditionCode: scope.row.modifyEditionCode}})">
          {{ $t('lang.查看') }}
        </el-button>
        <el-button size="mini" plain type="primary" @click="handleCopy(scope.row)">{{ $t('lang.复制') }}</el-button>

        <el-button size="mini" plain type="primary" @click="handlePreview(scope.row)">{{ $t('lang.预览') }}</el-button>
        <el-button size="mini" @click="handleAudit(scope.row)" plain type="success">{{ $t('lang.审核通过') }}
        </el-button>
        <el-button size="mini" plain type="warning" @click="handleRecall(scope.row)">{{ $t('lang.撤回') }}</el-button>
        <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
      </template>
    </el-table-column>


  </el-table>
</template>

<script>
import NationList from "../nation/NationList";

export default {
  name: "ReleasedTable",
  components: {NationList},
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      that: this,
    }
  },
  methods: {
    // 食谱预览
    handlePreview(row) {
      this.$router.push({
        path: '/preview-detail',
        query: {
          recipeEditionCode: row.modifyEditionCode,
          number: row.number
        }
      })
    },
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },
    handleDelete(row) {
      this.$emit('remove', row);
    },
    handleAudit(row) {
      let codes = [row.code]
      this.$emit('audit', codes);
    },
    handleRecall(row) {
      let codes = [row.code]
      this.$emit('recall', codes);
    },
    handleCopy(row) {
      this.$emit('copy', row)
    }
  },
  filters: {
    filterProduct(list) {
      if (Array.isArray(list)) {
        return list.join('/');
      }
      return ''
    }
  },
}
</script>

<style scoped lang="scss">

</style>
